import initialState from '../../demoData/testUsers.json';

const userProfileReducer = (state = initialState) => {
    return state;
};

export { userProfileReducer };
